var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsPlatformDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.298 3.90479H10.1065C8.29264 3.90479 6.82508 5.3984 6.82508 7.22393L6.80859 33.7771C6.80859 35.6027 8.27615 37.0963 10.09 37.0963H29.8937C31.7075 37.0963 33.1916 35.6027 33.1916 33.7771V13.8622L23.298 3.90479ZM29.8937 33.7771H10.1065V7.22393H21.649V15.5218H29.8937V33.7771Z",
    fill: "#4C5E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0018 18C17.9794 17.9993 16.1557 19.217 15.3812 21.0853C14.6068 22.9536 15.0341 25.1045 16.464 26.5348C17.8938 27.9651 20.0445 28.3932 21.9131 27.6194C23.7816 26.8456 25 25.0224 25 22.9999C25 20.2392 22.7625 18.001 20.0018 18ZM20.0018 26.0895C18.7512 26.0902 17.6233 25.3373 17.1444 24.182C16.6655 23.0267 16.9299 21.6966 17.8142 20.8123C18.6985 19.928 20.0286 19.6636 21.1839 20.1425C22.3392 20.6214 23.0921 21.7493 23.0914 22.9999C23.0904 24.7059 21.7077 26.0885 20.0018 26.0895Z",
    fill: "#4C5E6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4697 30.4805V28.808H21.7139V30.4805H18.4697Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPlatformDocument);
export default __webpack_public_path__ + "static/media/icons_platform_document.7bd729dd.svg";
export { ForwardRef as ReactComponent };